module.exports = __webpack_public_path__ + "img/logo-durand-branco.44cce2b7.png";